import { useContext } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import PageHero from "../components/PageHero";
import Experience from "../components/Experience";
import Breakfast from "../components/Breakfast";
import { LanguageContext } from "../App";
import { IMAGES } from "../translations";

export default function ExperiencePage() {
  const { t } = useContext(LanguageContext);

  return (
    <>
      <PageHero
        image={IMAGES.experience_hero}
        overline={t.experience.overline}
        title={t.experience.hero_title}
        mode="contain"
      />
      <Experience />
      <Breakfast />

      <section className="bg-[#F3F1EC] py-16 px-6 text-center" data-testid="exp-cta-section">
        <motion.div
          initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }} transition={{ duration: 0.8 }}
        >
          <Link
            to="/prenota"
            data-testid="exp-page-book-btn"
            className="inline-flex items-center justify-center bg-[#7B907F] text-white font-['Manrope',sans-serif] text-xs uppercase tracking-[0.25em] w-full sm:w-auto px-12 py-5 hover:bg-[#687A6C] transition-all duration-300"
          >
            {t.contact.cta_button}
          </Link>
        </motion.div>
      </section>
    </>
  );
}
